import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
export function usePrependToCachedListQueryData(key) {
  const queryClient = useQueryClient();
  return useCallback(newItem => {
    const updater = oldQuery => {
      if (oldQuery) {
        const {
          meta,
          items: oldItems
        } = oldQuery;
        return {
          meta: {
            ...meta,
            totalItems: meta.totalItems + 1
          },
          items: [newItem, ...(oldItems.length === meta.itemsPerPage ? oldItems.slice(0, -1) : oldItems)]
        };
      } else {
        return {
          items: [newItem],
          meta: {
            itemsPerPage: 1,
            page: 0,
            totalItems: 1
          }
        };
      }
    };
    queryClient.setQueryData(key, updater);
  }, [key, queryClient]);
}